module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader",
      rawName: "v-loader.users",
      value: ({
        delay: 0
      }),
      expression: "{ delay: 0 }",
      modifiers: {
        "users": true
      }
    }],
    staticClass: "tools-tab tools-tab-user",
    class: [_vm.$onduro.hasModule('availability') ? 'has-availability' : '', _vm.item.tags.length ? 'is-filtered' : '']
  }, [(!_vm.loading) ? [(!_vm.applicants.length) ? _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.users), function(user) {
    return _c('li', {
      class: [_vm.hasUser(user) ? 'is-active' : ''],
      on: {
        "click": function($event) {
          return _vm.select(user)
        }
      }
    }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
      class: _vm.getAvailabilityClasses(user),
      on: {
        "mouseover": function($event) {
          return _vm.showAvailability(user)
        },
        "mouseout": function($event) {
          return _vm.hideAvailability()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.hasUser(user)) ? _c('icon', {
      attrs: {
        "name": "delete"
      }
    }) : (_vm.multiple) ? _c('icon', {
      attrs: {
        "name": "add"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0) : _c('ul', {
    staticClass: "list"
  }, [_vm._l((_vm.applicants), function(user) {
    return _c('li', {
      class: [_vm.hasUser(user) ? 'is-active' : '', user.planned ? 'is-planned' : ''],
      on: {
        "click": function($event) {
          return _vm.select(user)
        }
      }
    }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
      class: _vm.getAvailabilityClasses(user),
      on: {
        "mouseover": function($event) {
          return _vm.showAvailability(user)
        },
        "mouseout": function($event) {
          return _vm.hideAvailability()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('span', {
      staticClass: "applied-at",
      domProps: {
        "innerHTML": _vm._s(_vm.$t('page.roster.tools.applied_at', {
          date: _vm.humanDate(user.appliedAt)
        }))
      }
    }), _vm._v(" "), (_vm.hasUser(user)) ? _c('icon', {
      attrs: {
        "name": "delete"
      }
    }) : (_vm.multiple) ? _c('icon', {
      attrs: {
        "name": "add"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.remaining), function(user, index) {
    return (!_vm.$onduro.getConfig('restrict.planner')) ? _c('li', {
      class: [_vm.hasUser(user) ? 'is-active' : '', index === 0 ? 'border-top' : ''],
      on: {
        "click": function($event) {
          return _vm.select(user)
        }
      }
    }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
      class: _vm.getAvailabilityClasses(user),
      on: {
        "mouseover": function($event) {
          return _vm.showAvailability(user)
        },
        "mouseout": function($event) {
          return _vm.hideAvailability()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.hasUser(user)) ? _c('icon', {
      attrs: {
        "name": "delete"
      }
    }) : (_vm.multiple) ? _c('icon', {
      attrs: {
        "name": "add"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), (!_vm.users.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('page.roster.tools.empty_users')) + "\n        ")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.tags.length),
      expression: "item.tags.length"
    }],
    staticClass: "filtered"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.roster.tools.filtered_tags')) + "\n    ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a88ddf0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/User.vue
// module id = 598
// module chunks = 234